import { useMemo, type ComponentProps } from 'react';
import { useMatch } from 'react-router-dom';
import { Button, IconLucide } from '@yakit/ui-components';

import { useVDLStore } from '@VDL/store/VDLstore';

import { initialInLevelState } from '@VDL/types/VDLInLevelState';
import { initialHomeState } from '@VDL/types/VDLHomeState';

export const VDLToolbarBackButton = ({
  ...props
}: ComponentProps<typeof Button>) => {
  const matchLevel0 = useMatch(':level0Code/*');
  const { inLevelState, setInLevelState, homeState, setHomeState } =
    useVDLStore();

  const handleBackClick = () => {
    if (inLevelState.haveBackButton) {
      setInLevelState(initialInLevelState);
    } else if (homeState.haveBackButton) {
      setHomeState(initialHomeState);
    }
  };

  const { title, showButton } = useMemo(() => {
    if (
      (matchLevel0 && inLevelState.haveBackButton) ||
      homeState.haveBackButton
    ) {
      return {
        title: inLevelState.title ?? homeState.title ?? '',
        showButton: true
      };
    } else
      return {
        title: '',
        showButton: false
      };
  }, [matchLevel0, inLevelState, homeState]);

  if (!showButton) return null;

  return (
    <Button {...props} title={title} onClick={handleBackClick}>
      <IconLucide name="CornerLeftDown" className="mr-2 h-3 w-3" />
      Назад
    </Button>
  );
};
